var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPictogramBeaconUtilities128(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 128,
    height: 129,
    viewBox: "0 0 128 129",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2589_10872)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M106.6 112.503V59.1934L62 90.0029L17 59.1934V112.503H106.6Z",
    fill: "white",
    stroke: "#1E1E1E",
    strokeWidth: 1.8,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30 51.1133L17 59.1574L61.8 90.003L61.8277 89.9839L30 68.003L30 51.1133ZM94.0001 67.8326L106.6 59.1574L94.0001 51.3609V67.8326Z",
    fill: "#FAEC20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30 51.1133L30.9 51.1133C30.9 50.7868 30.7233 50.486 30.4381 50.3271C30.1529 50.1682 29.8041 50.1762 29.5265 50.3479L30 51.1133ZM17 59.1574L16.5264 58.392C16.268 58.552 16.1077 58.8315 16.1003 59.1354C16.0928 59.4392 16.2393 59.7263 16.4896 59.8987L17 59.1574ZM61.8 90.003L61.2896 90.7442C61.597 90.9559 62.003 90.9559 62.3104 90.7442L61.8 90.003ZM61.8277 89.9839L62.3381 90.7252C62.5818 90.5573 62.7275 90.2804 62.7277 89.9845C62.7279 89.6886 62.5827 89.4115 62.3392 89.2433L61.8277 89.9839ZM30 68.003L29.1 68.003C29.1 68.2987 29.2452 68.5755 29.4886 68.7435L30 68.003ZM94.0001 67.8326H93.1001C93.1001 68.1669 93.2855 68.4737 93.5814 68.6293C93.8774 68.7848 94.2352 68.7635 94.5105 68.5739L94.0001 67.8326ZM106.6 59.1574L107.11 59.8987C107.361 59.7263 107.507 59.4392 107.5 59.1354C107.492 58.8315 107.332 58.552 107.074 58.392L106.6 59.1574ZM94.0001 51.3609L94.4737 50.5956C94.1961 50.4238 93.8473 50.4158 93.5621 50.5747C93.2769 50.7336 93.1001 51.0345 93.1001 51.3609H94.0001ZM29.5265 50.3479L16.5264 58.392L17.4736 59.9227L30.4736 51.8786L29.5265 50.3479ZM16.4896 59.8987L61.2896 90.7442L62.3104 89.2617L17.5104 58.4161L16.4896 59.8987ZM62.3104 90.7442L62.3381 90.7252L61.3173 89.2426L61.2896 89.2617L62.3104 90.7442ZM62.3392 89.2433L30.5114 67.2624L29.4886 68.7435L61.3163 90.7244L62.3392 89.2433ZM30.9 68.003L30.9 51.1133L29.1 51.1133L29.1 68.003L30.9 68.003ZM94.5105 68.5739L107.11 59.8987L106.09 58.4161L93.4898 67.0913L94.5105 68.5739ZM107.074 58.392L94.4737 50.5956L93.5266 52.1262L106.126 59.9227L107.074 58.392ZM93.1001 51.3609V67.8326H94.9001V51.3609H93.1001Z",
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.0001 16.5029L94.0001 16.5029V67.818L62.0001 90.1029L30 68.0029L30.0001 16.5029Z",
    fill: "white",
    stroke: "#1E1E1E",
    strokeWidth: 1.8,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.0361 33.7114H51.5227",
    stroke: "#1E1E1E",
    strokeWidth: 1.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.0361 26.356H62.312",
    stroke: "#1E1E1E",
    strokeWidth: 1.8
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M79.4836 28.2363V45.303H86.0397L70.7421 68.7697V51.703H64.186L79.4836 28.2363Z",
    fill: "#FAEC20",
    stroke: "#1E1E1E",
    strokeWidth: 1.8,
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2589_10872"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 128,
    height: 128,
    fill: "white",
    transform: "translate(0 0.50293)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPictogramBeaconUtilities128);
export default __webpack_public_path__ + "static/media/pictogramBeaconUtilities128.5d7e05ef16adc3f2647548b048538c27.svg";
export { ForwardRef as ReactComponent };